<template>
  <div class="dc-js-chart row-chart">
    <div class="header">
      <slot>
        <h2>
          {{ title }}
        </h2>
      </slot>
      <a class="reset" @click="reset()" style="display: none">
        <i class="material-icons refresh button">refresh</i>
      </a>
    </div>

    <a
      href="javascript:;"
      class="download-data"
      :download="downloadName"
      title="Download data"
      @mouseenter="setDownloadData()"
    >
      <i class="material-icons get-app">get_app</i>
    </a>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  with: 220,
  height: 500,
  props: {
    downloadName: {
      type: String,
      default: 'download.csv'
    },
    downloadColumns: {
      type: Array,
      default() { return ['Key', 'Value'] }
    },
  },
  methods: {
    createChart(ndx) {
      this.chart = dc.rowChart(this.$el);
      const dimension = ndx.dimension(d => d[this.dimensionField]);
      const group = dimension.group().reduceSum(d => d[this.aggField]);

      this.chart
        .width(this.$options.width)
        .height(this.$options.height)
        .margins({ top: 10, right: 10, bottom: 20, left: 10 })
        .dimension(dimension)
        .group(group)
        .ordering(d => {
          return d.value * -1;
        })
        .ordinalColors(this.colors)
        .cap(20)
        .title(this.titleFn)
        .label(this.labelFn)
        .elasticX(true)
        .xAxis()
        .ticks(4);
    },
    //
    setDownloadData() {
      let arr = [this.downloadColumns.join(',')];

      this.chart.data().forEach(d => { arr.push([d.key, d.value].join(',')) });

      this.$el.querySelector('a.download-data').href = 'data:text/csv;charset=utf-8,' + arr.join('\n');
    }
  },
};
</script>

<style>
.row-chart {
  position: relative;
}
.row-chart .download-data {
  position: absolute;
  right: 50px;
  top: 23px;
  color: #333;
}
</style>
